import { useEffect, useRef } from 'react';

type CompanyLike = { name: string };

export function useCompanyAccessGuard(
  currentCompanyName: string | undefined,
  companies: CompanyLike[] | undefined,
  onReset: (allowedCompanyName: string) => void
) {
  const onResetRef = useRef(onReset);
  onResetRef.current = onReset;

  useEffect(() => {
    if (!companies || companies.length === 0) return;
    if (!currentCompanyName) return;
    if (companies.some((c) => c.name === currentCompanyName)) return;
    onResetRef.current(companies[0].name);
  }, [companies, currentCompanyName]);
}
